const cookieConsentI18n = {
  "fr": {
    "consent": {
      "banner": {
        "title": "Cookies & confidentialité",
        "text": "Nous utilisons des cookies pour le fonctionnement du site et pour mesurer l’audience (Google Analytics). Vous pouvez accepter, refuser ou paramétrer vos choix."
      },
      "actions": {
        "reject": "Refuser",
        "settings": "Paramétrer",
        "accept": "Accepter",
        "acceptAll": "Tout accepter",
        "save": "Enregistrer"
      },
      "dialog": {
        "title": "Préférences des cookies",
        "intro": "Activez/désactivez les catégories ci-dessous. Les cookies « essentiels » sont toujours actifs.",
        "gaLine": "Outil : Google Analytics 4 — IP anonymisée. ID :",
        "gaUnset": "non configuré",
        "footer": "Vous pourrez modifier vos choix à tout moment depuis la page « Cookies » ou le lien en bas de page."
      },
      "switch": {
        "on": "Activé",
        "off": "Désactivé"
      },
      "cats": {
        "essential": {
          "label": "Essentiels",
          "desc": "Nécessaires au fonctionnement du site (sécurité, session...)."
        },
        "analytics": {
          "label": "Mesure d’audience",
          "desc": "Google Analytics 4 (pages vues, parcours). Données agrégées."
        },
        "performance": {
          "label": "Performance",
          "desc": "Cache, optimisation UX, éventuels tests A/B."
        },
        "marketing": {
          "label": "Marketing",
          "desc": "Personnalisation et suivi des campagnes."
        }
      }
    }
  },
  "en": {
    "consent": {
      "banner": {
        "title": "Cookies & privacy",
        "text": "We use cookies for website operation and audience measurement (Google Analytics). You can accept, refuse, or manage your choices."
      },
      "actions": {
        "reject": "Reject",
        "settings": "Manage",
        "accept": "Accept",
        "acceptAll": "Accept all",
        "save": "Save"
      },
      "dialog": {
        "title": "Cookie preferences",
        "intro": "Enable/disable the categories below. “Essential” cookies are always on.",
        "gaLine": "Tool: Google Analytics 4 — IP anonymized. ID:",
        "gaUnset": "not configured",
        "footer": "You can change your choices at any time from the “Cookies” page or the footer link."
      },
      "switch": {
        "on": "On",
        "off": "Off"
      },
      "cats": {
        "essential": {
          "label": "Essential",
          "desc": "Required for the site to function (security, session, etc.)."
        },
        "analytics": {
          "label": "Analytics",
          "desc": "Google Analytics 4 (page views, journeys). Aggregated data."
        },
        "performance": {
          "label": "Performance",
          "desc": "Caching, UX optimization, possible A/B tests."
        },
        "marketing": {
          "label": "Marketing",
          "desc": "Personalization and campaign tracking."
        }
      }
    }
  },
  "pl": {
    "consent": {
      "banner": {
        "title": "Ciasteczka i prywatność",
        "text": "Używamy plików cookie do działania strony oraz pomiaru oglądalności (Google Analytics). Możesz zaakceptować, odrzucić lub dostosować swoje wybory."
      },
      "actions": {
        "reject": "Odrzuć",
        "settings": "Ustawienia",
        "accept": "Akceptuj",
        "acceptAll": "Akceptuj wszystkie",
        "save": "Zapisz"
      },
      "dialog": {
        "title": "Preferencje plików cookie",
        "intro": "Włącz/wyłącz kategorie poniżej. „Niezbędne” pliki cookie są zawsze aktywne.",
        "gaLine": "Narzędzie: Google Analytics 4 — IP zanonimizowany. ID:",
        "gaUnset": "brak konfiguracji",
        "footer": "Możesz zmieniać wybory w każdej chwili na stronie „Cookies” lub w linku w stopce."
      },
      "switch": {
        "on": "Włączone",
        "off": "Wyłączone"
      },
      "cats": {
        "essential": {
          "label": "Niezbędne",
          "desc": "Wymagane do działania strony (bezpieczeństwo, sesja itp.)."
        },
        "analytics": {
          "label": "Analityka",
          "desc": "Google Analytics 4 (wyświetlenia stron, ścieżki). Dane zagregowane."
        },
        "performance": {
          "label": "Wydajność",
          "desc": "Cache, optymalizacja UX, możliwe testy A/B."
        },
        "marketing": {
          "label": "Marketing",
          "desc": "Personalizacja i śledzenie kampanii."
        }
      }
    }
  },
  "es": {
    "consent": {
      "banner": {
        "title": "Cookies y privacidad",
        "text": "Utilizamos cookies para el funcionamiento del sitio y para medir la audiencia (Google Analytics). Puedes aceptar, rechazar o configurar tus preferencias."
      },
      "actions": {
        "reject": "Rechazar",
        "settings": "Configurar",
        "accept": "Aceptar",
        "acceptAll": "Aceptar todo",
        "save": "Guardar"
      },
      "dialog": {
        "title": "Preferencias de cookies",
        "intro": "Activa o desactiva las categorías de abajo. Las cookies “esenciales” siempre están activas.",
        "gaLine": "Herramienta: Google Analytics 4 — IP anonimizada. ID:",
        "gaUnset": "no configurado",
        "footer": "Puedes modificar tus elecciones en cualquier momento desde la página «Cookies» o desde el enlace en el pie de página."
      },
      "switch": {
        "on": "Activado",
        "off": "Desactivado"
      },
      "cats": {
        "essential": {
          "label": "Esenciales",
          "desc": "Necesarias para el funcionamiento del sitio (seguridad, sesión…)."
        },
        "analytics": {
          "label": "Analítica",
          "desc": "Google Analytics 4 (vistas de página, rutas). Datos agregados."
        },
        "performance": {
          "label": "Rendimiento",
          "desc": "Caché, optimización UX, posibles tests A/B."
        },
        "marketing": {
          "label": "Marketing",
          "desc": "Personalización y seguimiento de campañas."
        }
      }
    }
  },
  "it": {
    "consent": {
      "banner": {
        "title": "Cookie e privacy",
        "text": "Utilizziamo i cookie per il funzionamento del sito e la misurazione del pubblico (Google Analytics). Puoi accettare, rifiutare o gestire le tue scelte."
      },
      "actions": {
        "reject": "Rifiuti",
        "settings": "Gestione",
        "accept": "Accettare",
        "acceptAll": "Accettate tutti",
        "save": "Salva"
      },
      "dialog": {
        "title": "Preferenze sui cookie",
        "intro": "Attiva/disattiva le categorie qui sotto. I cookie “Essentiali” sono sempre accesi.",
        "gaLine": "Strumento: Google Analytics 4 — IP anonimizzato. ID:",
        "gaUnset": "non configurato",
        "footer": "Puoi cambiare le tue scelte in qualsiasi momento dalla pagina “Cookies” o dal link footer."
      },
      "switch": {
        "on": "Su",
        "off": "Fuori"
      },
      "cats": {
        "essential": {
          "label": "Essenziale",
          "desc": "Richiesto per il sito di funzionare (sicurezza, sessione, ecc.)."
        },
        "analytics": {
          "label": "Analisi",
          "desc": "Google Analytics 4 (pagine, viaggi). Dati aggregati."
        },
        "performance": {
          "label": "Prestazioni",
          "desc": "Caching, ottimizzazione UX, possibili test A/B."
        },
        "marketing": {
          "label": "Marketing",
          "desc": "Personalizzazione e monitoraggio delle campagne."
        }
      }
    }
  },
  "de": {
    "consent": {
      "banner": {
        "title": "Cookies und Privatsphäre",
        "text": "Wir verwenden Cookies für den Betrieb der Website und die Publikumsmessung (Google Analytics). Sie können Ihre Entscheidungen akzeptieren, ablehnen oder verwalten."
      },
      "actions": {
        "reject": "Ablehnung",
        "settings": "Verwalten",
        "accept": "Akzeptieren",
        "acceptAll": "Alle akzeptieren",
        "save": "Sparen"
      },
      "dialog": {
        "title": "Cookie Präferenzen",
        "intro": "Aktivieren/Deaktivieren der folgenden Kategorien. \"Wesentliche\" Cookies sind immer eingeschaltet.",
        "gaLine": "Tool: Google Analytics 4 — IP anonymisiert. ID:",
        "gaUnset": "nicht konfiguriert",
        "footer": "Sie können Ihre Auswahl jederzeit über die Seite „Cookies oder den Fußzeilenlink ändern."
      },
      "switch": {
        "on": "am",
        "off": "Ausgeschaltet"
      },
      "cats": {
        "essential": {
          "label": "Wichtig",
          "desc": "Erforderlich, damit die Site funktioniert (Sicherheit, Sitzung usw.)."
        },
        "analytics": {
          "label": "Analytik",
          "desc": "Google Analytics 4 (Seitenaufrufe, Reisen). Aggregierte Daten."
        },
        "performance": {
          "label": "Leistung",
          "desc": "Caching, UX Optimierung, mögliche A/B Tests."
        },
        "marketing": {
          "label": "Marketing",
          "desc": "Personalisierung und Kampagnentracking."
        }
      }
    }
  },
  "pt": {
    "consent": {
      "banner": {
        "title": "Cookies e privacidade",
        "text": "Usamos cookies para operação do site e medição do público (Google Analytics). Você pode aceitar, recusar ou gerenciar suas escolhas."
      },
      "actions": {
        "reject": "Rejeitar",
        "settings": "Gerenciar",
        "accept": "Aceitar",
        "acceptAll": "Aceitar tudo",
        "save": "Gravar"
      },
      "dialog": {
        "title": "Preferências de cookies",
        "intro": "Activar/desactivar as categorias abaixo. Os cookies “Essencial” estão sempre ligados.",
        "gaLine": "Ferramenta: Google Analytics 4 — Anonymized IP. ID:",
        "gaUnset": "não configurado",
        "footer": "Você pode alterar suas escolhas a qualquer momento da página “Cookies” ou do link do rodapé."
      },
      "switch": {
        "on": "Ligado",
        "off": "Desligado"
      },
      "cats": {
        "essential": {
          "label": "Essencial",
          "desc": "É necessário que o site funcione (segurança, sessão, etc.)."
        },
        "analytics": {
          "label": "Análise",
          "desc": "Google Analytics 4 (visitas de página, viagens). Dados agregados."
        },
        "performance": {
          "label": "Desempenho",
          "desc": "Caching, otimização de UX, possíveis testes A/B."
        },
        "marketing": {
          "label": "Comercialização",
          "desc": "Personalização e acompanhamento de campanha."
        }
      }
    }
  },
  "cs": {
    "consent": {
      "banner": {
        "title": "Cookies a soukromí",
        "text": "Pro provoz webových stránek a měření publika (Google Analytics) používáme cookies. Můžete přijmout, odmítnout nebo řídit svá rozhodnutí."
      },
      "actions": {
        "reject": "Odmítnout",
        "settings": "Správa",
        "accept": "Přijmout",
        "acceptAll": "Přijmout všechny",
        "save": "Uložit"
      },
      "dialog": {
        "title": "Cookie preference",
        "intro": "Povolit / zakázat níže uvedené kategorie. \"Základní\" sušenky jsou pořád zapnuté.",
        "gaLine": "Nástroj: Google Analytics 4 - IP anonymní. ID:",
        "gaUnset": "není nastaveno",
        "footer": "Můžete změnit své volby kdykoliv ze stránky \"Cookies\" nebo odkaz na footer."
      },
      "switch": {
        "on": "Zapnout",
        "off": "Vypnout"
      },
      "cats": {
        "essential": {
          "label": "Základní",
          "desc": "Vyžadováno pro funkci webu (bezpečnost, relace atd.)."
        },
        "analytics": {
          "label": "Analytika",
          "desc": "Google Analytics 4 (zobrazení stránky, cesty). Souhrnná data."
        },
        "performance": {
          "label": "Výkonnost",
          "desc": "Caching, UX optimalizace, možné A / B testy."
        },
        "marketing": {
          "label": "Uvádění na trh",
          "desc": "Personalizace a sledování kampaně."
        }
      }
    }
  },
  "nl": {
    "consent": {
      "banner": {
        "title": "Cookies & privacy",
        "text": "Wij gebruiken cookies voor website- en publieksmeting (Google Analytics). U kunt uw keuzes accepteren, weigeren of beheren."
      },
      "actions": {
        "reject": "Weigeren",
        "settings": "Beheer",
        "accept": "Accepteren",
        "acceptAll": "Alles accepteren",
        "save": "Opslaan"
      },
      "dialog": {
        "title": "Cookievoorkeuren",
        "intro": "Schakel de onderstaande categorieën in/uit. De cookies van Essential zijn altijd aan.",
        "gaLine": "Tool: Google Analytics 4 Geanonimiseerd IP. ID:",
        "gaUnset": "niet geconfigureerd",
        "footer": "U kunt uw keuzes op elk gewenst moment van de pagina Cookies of de voettekst link."
      },
      "switch": {
        "on": "Aan",
        "off": "Uit"
      },
      "cats": {
        "essential": {
          "label": "Essentieel",
          "desc": "Vereist voor de site om te functioneren (veiligheid, sessie, enz.)."
        },
        "analytics": {
          "label": "Analyse",
          "desc": "Google Analytics 4 (paginaweergaven, reizen). Geaggregeerde gegevens."
        },
        "performance": {
          "label": "Prestaties",
          "desc": "Caching, UX optimalisatie, mogelijke A/B testen."
        },
        "marketing": {
          "label": "Verkoop",
          "desc": "Persoonlijkheid en campagne volgen."
        }
      }
    }
  }
};

export default cookieConsentI18n;
